export default "/static/4c3b5e96786da5e6.svg"